import { authAxios } from '@/axios/axios';

export const getReservation = async (id) => {
    const { data } = await authAxios.get(`reservations/${id}`);
    return data;
}

export const getReservationsByDate = async date => {
    const { data } = await authAxios.get(`reservations/filtered-reservations/?date=${date}`);
    return data;
}

export const getReservationsByMonth = async (month, year) => {
    const { data } = await authAxios.get(`reservations/filtered-reservations/?month=${month}&year=${year}`);
    return data;
}

export const getReservationsCountByMonth = async (month, year) => {
    const { data } = await authAxios.get(`reservations/filtered-reservations/count/?month=${month}&year=${year}`);
    return data;
}

export const postReservation = async (reservation) => {
    const { data } = await authAxios.post("reservations/", reservation);
    return data;
}


// WEBPACK FOOTER //
// ./src/queries/reservations/requests.js